import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Ensure the component is mounted before starting animations
    setIsLoaded(true);
  }, []);

  return (
    <div className="relative w-screen h-[100dvh] bg-black overflow-hidden flex flex-col items-center justify-center selection:bg-white/10 selection:text-white font-sans">
      
      {/* --- AMBIENT BACKGROUND LAYER (True Cinema Black) --- */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden bg-black">
        {/* Microscopic 35mm Film Grain - No light bleed or glowing gradients */}
        <div className="film-grain-overlay"></div>
      </div>

      {/* --- CONTENT LAYER --- */}
      <AnimatePresence>
        {isLoaded && (
          <div className="relative z-20 flex flex-col items-center text-center w-full max-w-screen-2xl px-4">
            
            {/* MAIN TITLE (Stark & Monolithic) */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ 
                delay: 1.5, 
                duration: 3, 
                ease: "linear" // Pure slow-burn light fade, no scaling or easing tricks
              }}
              className="flex flex-col items-center justify-center w-full"
            >
              <h1 className="flex flex-col items-center uppercase m-0 p-0 w-full text-white">
                
                {/* LINE 1: UNDER THE */}
                <span className="font-semibold text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl tracking-[-0.03em] leading-none mb-2 md:mb-4">
                  Under The
                </span>
                
                {/* LINE 2: NAME (Legible negative tracking for a readable but immovable block) */}
                <span className="font-black text-[6rem] sm:text-[9rem] md:text-[13rem] lg:text-[17rem] xl:text-[20rem] tracking-[-0.02em] leading-[0.75] w-full block">
                  Name
                </span>
                
              </h1>
            </motion.div>

            {/* ELEMENT A: THE TAGLINE */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ 
                delay: 5.5, // 1 second after Main Title finishes fading in (1.5 + 3 + 1)
                duration: 2.5, 
                ease: "linear" 
              }}
              className="mt-12 sm:mt-16 md:mt-20 w-full px-8"
            >
              <p className="text-[#A0A0A0] font-normal text-xs sm:text-sm md:text-base tracking-[0.25em] uppercase m-0">
                Every name carries a story.
              </p>
            </motion.div>

            {/* ELEMENT B: THE TEASE */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ 
                delay: 7.5, // Fades in last, completing the sequence
                duration: 2.5, 
                ease: "linear" 
              }}
              className="mt-24 sm:mt-32 md:mt-40 w-full px-8"
            >
              <p className="text-[#A0A0A0] font-normal text-[0.65rem] sm:text-xs md:text-sm tracking-[0.3em] uppercase m-0">
                Coming Soon
              </p>
            </motion.div>

          </div>
        )}
      </AnimatePresence>
      
    </div>
  );
}

export default App;